import { LOGOUT } from './auth';

const GET_WALLETS = 'wallets/GET';
const GET_WALLETS_SUCCESS = 'wallets/GET_SUCCESS';
const GET_WALLETS_FAIL = 'wallets/GET_FAIL';
const SEND = 'wallets/SEND';
const SEND_SUCCESS = 'wallets/SEND_SUCCESS';
const SEND_FAIL = 'wallets/SEND_FAIL';
const TOPUP = 'wallets/TOPUP';
const TOPUP_SUCCESS = 'wallets/TOPUP_SUCCESS';
const TOPUP_FAIL = 'wallets/TOPUP_FAIL';

const initialState = {
  loaded: false,
  data: [],
};

export default function wallets(state = initialState, action = {}) {
  switch (action.type) {
    case GET_WALLETS_SUCCESS:
      return {
        ...state,
        loaded: true,
        currentWallet: action.result.find(wallet => wallet.default),
      };
    case GET_WALLETS_FAIL:
      return {
        ...state,
        loaded: true,
        error: action.error,
      };
    case TOPUP_SUCCESS:
      return {
        ...state,
        topupUri: action.result.uri,
      };
    case LOGOUT:
      return { ...initialState, loaded: true };
    default:
      return state;
  }
}

export function getWallets() {
  return {
    types: [GET_WALLETS, GET_WALLETS_SUCCESS, GET_WALLETS_FAIL],
    promise: async ({ client }) => {
      const { data } = await client.get('/v1/wallets');
      return data;
    },
  };
}
export function send(receiver, amount, data, asset) {
  return {
    types: [SEND, SEND_SUCCESS, SEND_FAIL],
    promise: async ({ client }) => {
      const { data: transactionData } = await client.post(
        '/v1/wallets/send',
        {
          asset,
          receiver,
          amount,
          data,
        },
        { timeout: 1000 * 60 }
      );
      return { transactionData, amount };
    },
  };
}
export function topup() {
  return {
    types: [TOPUP, TOPUP_SUCCESS, TOPUP_FAIL],
    promise: async ({ client }) => {
      const { data } = await client.get('/v1/wallets/topup');
      return data;
    },
  };
}
